<template>
	<div id="app">
		<!-- <Topbar></Topbar> -->
		<transition name="fade">
		<Header v-if="haslogin" :hasShow="hasShow"></Header>
		<headerLogin v-if="!haslogin" :hasShow="hasShow"></headerLogin>
		</transition>
		<section class="section">
			<router-view />
		</section>
		<Footer :isActive="isActive" :hasShow="hasShow"></Footer>
	</div>
</template>
<script>
	import Footer from '@/components/Footer.vue'
	import Header from '@/components/Header.vue'
	import headerLogin from '@/components/headerLogin.vue'
	// import Topbar from '@/components/Topbar.vue'
	export default {
		name: '',
		components: {
			Header,
			Footer,
			headerLogin
		},
		data() {
			return {
				isActive: true,
				haslogin: true,
				hasShow:false,
			}
		},
		watch: {
		    '$route'(to, from) {
				//console.log(to.path.indexOf('/download/')!=-1)
				// 路由变化时的处理逻辑
				if(to.path=='/register'){
					this.haslogin=false;
				}else{
					this.haslogin=true;
				}
				//区分是否需要头部和底部
				if(to.path.indexOf('/download/')!=-1){
					this.hasShow=false;
				}else{
					this.hasShow=true;
				}
		    }
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>
<style>
	.section{
		min-height: calc( 100vh - 74px );
	}
	::v-deep .el-popover{
		width: 125px !important;
		min-width: 125px !important;
	}
	.popperClass{
		width: 125px !important;
		min-width: 125px !important;
	}
	
	.popperClass2{
		width: 185px !important;
		min-width: 185px !important;
		padding: 0 !important;
		margin-left: 20px;
		margin-bottom: 20px !important;
	}
	/* 全局禁用光标与文字选中 */
	* {
	  user-select: none !important;
	  -webkit-user-select: none !important;
	  outline: none !important;
	  -webkit-tap-highlight-color: transparent !important;
	}
</style>